import { createAction, props } from '@ngrx/store';

export interface singleEdit{
    id: string,
    fundingControl: string | null,
    scoreControl: string | null,
    formStatus: boolean,
    comment: string | null
}

export interface OECIF_Form{
    id: string,
    formStatus: boolean | null,
    oge450: boolean | null,
    recuse: boolean | null,
    oe_impact: boolean | null
    technical: boolean | null,
    jointness: boolean | null,
    jointnessNarrative: boolean | null,
    financial: boolean | null,
    financial2: boolean | null,
    teamQuality: boolean | null,
    teamComplete: boolean | null,
    warfighter: boolean | null,
    transition: boolean | null,
    EWEVDM_metering: boolean | null,
    EWEVDM_operations: boolean | null,
    EWEVDM_mission: boolean | null,
    EWEVDM_modeling: boolean | null,
    EWEVDM_training: boolean | null,
    EWEVDM_analytics: boolean | null,
    comment: string | null
}
export interface OEPF_Form{
    id: string,
    formStatus: boolean | null,
    oge450: boolean | null,
    recuse: boolean | null,
    oe_impact: boolean | null
    technical: boolean | null,
    jointness: boolean | null,
    jointnessNarrative: boolean | null,
    financial: boolean | null,
    financial2: boolean | null,
    teamQuality: boolean | null,
    teamComplete: boolean | null,
    warfighter: boolean | null,
    transition: boolean | null,
    transitionLetterSupport: boolean | null,
    EWEVDM_metering: boolean | null,
    EWEVDM_operations: boolean | null,
    EWEVDM_mission: boolean | null,
    EWEVDM_modeling: boolean | null,
    EWEVDM_training: boolean | null,
    EWEVDM_analytics: boolean | null,
    comment: string | null
}


export interface rankInfo{
    currentIndex: number,
    previousIndex: number
}


export const editFULLOECIF = createAction('[FULL List] OECIF Edit', props<{listItem:OECIF_Form}>());
export const editFULLOEPF = createAction('[FULL List] OEPF Edit', props<{listItem:OEPF_Form}>());




export const rankChangeFull = createAction('[Full List] Rank Order Changed Requested', props<{rankInfo:rankInfo}>());

export const rankFullChangeSuccess = createAction('[FULL List] Rank Order Changed Success');
export const rankFullChangeFail = createAction('[FULL List] Rank Order Changed Failure');

export const clearFullList = createAction('[FULL List] Clear request');



export const reset = createAction('[Seo List] Reset');
export const apiCallSeo = createAction('[Seo List] Api call');
export const loadSeoList = createAction('[Seo List] Started api call to load')
export const loadSeoListSucess = createAction('[Seo List] Api load sucess', props<{seoList:[]}>())
export const loadSeoListFailure = createAction('[Seo List] Api load Failure', props<{error:string}>())

export const loadFullList = createAction('[Full List] Started api call to load', props<{user:string}>())

export const loadFullListSucess = createAction('[Full List] Api load sucess', props<{fullList:[]}>())

export const loadFullListFailure = createAction('[Full List] Api load Failure', props<{error:string}>())

export const selectProposalFull = createAction('[Full List] Seo Proposal Selected', props<{propUUID:any}>());


export const updateFullListFromRecuse = createAction('[UPDATE Full List] update quad list from recuse', props<{fullList:[]}>())
export const unSelectFull = createAction('[UNSELECT Full] unselected Full')